export const parseFarmerProfile = () => {
    try {
        return JSON.parse(localStorage.getItem("profile"))
    } catch {
        return null
    }
}